// Photo-based garments — rigid objects (mug, bottle) where a real product photo
// makes more sense than a vector illustration. Clothing garments (t-shirt, hoodie,
// polo, caps) live in garments-vector-data.js as flat vector illustrations instead —
// see that file for why.
window.GARMENTS = [
  {
    showTechnique: false,
    showColor: true,
    showSize: false,
    id: "mug",
    name: "Mug",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTQgNCBIMTUgVjE3IEMxNSAxOSAxMy41IDIwIDEyIDIwIEg3IEM1LjUgMjAgNCAxOSA0IDE3IFoiLz48cGF0aCBkPSJNMTUgNi41IEgxOCBDMTkuNSA2LjUgMjAuNSA3LjcgMjAuNSA5LjUgQzIwLjUgMTEuMyAxOS41IDEyLjUgMTggMTIuNSBIMTUiLz48L3N2Zz4=",
    // Shares the "mug" category with Artmug below — two items means the
    // picker shows a sub-screen to choose between them (see the "cap"
    // garments for the same pattern).
    category: "mug",
    variantLabel: "Popmug",
    categoryOrder: 1,
    // Matches this garment to a real Shopify product tagged "Blanks" whose
    // Product Type is "MUG" (see design-tool.liquid / window.DT_BLANK_PRODUCTS).
    productType: "MUG",
    // This reference image is a flat wraparound print template (dashed
    // safe-zone + grid), not a photo of a physical mug — it has no fabric
    // texture to smooth, so the recolour pipeline's smoothing blur is
    // skipped for it (see garment.flatArtwork in design-tool.js), otherwise
    // its crisp dashed/grid lines come out blurred.
    flatArtwork: true,
    // The template's centre patch (the same rect as photoViews.front.zone
    // below) is the actual print/logo area on the real mug, which stays
    // white on every colour of this mug — only the grey rim band around it
    // represents the ceramic body and should pick up the chosen colour.
    keepZoneWhite: true,
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
      detail: "M140,70 Q175,70 175,110 Q175,150 140,150",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": { image: "//conquistadorapparel.com/cdn/shop/t/8/assets/mug-wrap-original.png", label: "Front", zone: { xPct: 9.5, yPct: 14.9, wPct: 79.6, hPct: 45.3 } },
    },
  },
  {
    showTechnique: false,
    showColor: false,
    showSize: false,
    id: "mug-artmug",
    name: "Mug",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTQgNCBIMTUgVjE3IEMxNSAxOSAxMy41IDIwIDEyIDIwIEg3IEM1LjUgMjAgNCAxOSA0IDE3IFoiLz48cGF0aCBkPSJNMTUgNi41IEgxOCBDMTkuNSA2LjUgMjAuNSA3LjcgMjAuNSA5LjUgQzIwLjUgMTEuMyAxOS41IDEyLjUgMTggMTIuNSBIMTUiLz48L3N2Zz4=",
    // Shares the "mug" category with Popmug above.
    category: "mug",
    variantLabel: "Artmug",
    categoryOrder: 2,
    // Matches this garment to a real Shopify product tagged "Blanks" whose
    // Product Type is "MUG-ARTMUG" (see design-tool.liquid / window.DT_BLANK_PRODUCTS).
    productType: "MUG-ARTMUG",
    // Same generic wraparound print template as Popmug — Artmug is white-only
    // (AAA-grade ceramic, no coloured interior/handle), so there's no real
    // photo to recolour anyway; this template is just the design/logo
    // placement guide.
    flatArtwork: true,
    keepZoneWhite: true,
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
      detail: "M140,70 Q175,70 175,110 Q175,150 140,150",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": { image: "//conquistadorapparel.com/cdn/shop/t/8/assets/mug-wrap-original.png", label: "Front", zone: { xPct: 9.2, yPct: 14.9, wPct: 79.6, hPct: 45.3 } },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    categoryOrder: 0,
    variantLabel: "Stainless Bottle",
    id: "bottle",
    realWidthCm: 22, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Stainless Bottle",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTEwIDIgSDE0IFY1LjUgTDE1LjUgNy41IFYyMSBDMTUuNSAyMiAxNC43IDIyLjUgMTMuOCAyMi41IEgxMC4yIEM5LjMgMjIuNSA4LjUgMjIgOC41IDIxIFY3LjUgTDEwIDUuNSBaIi8+PHBhdGggZD0iTTkgMTIgSDE1Ii8+PC9zdmc+",
    category: "bottle",
    // Matches this garment to a real Shopify product tagged "Blanks" whose
    // Product Type is "BOTTLE" (see design-tool.liquid / window.DT_BLANK_PRODUCTS).
    productType: "BOTTLE",
    // Same flat wraparound-template situation as the mug above — skip the
    // recolour pipeline's smoothing blur so the crisp dashed/grid lines stay sharp.
    flatArtwork: true,
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M80,20 L120,20 L120,45 L130,60 L130,220 L70,220 L70,60 L80,45 Z",
      detail: "M75,60 L125,60",
    },
    safeZones: [{ x: 30, y: 30, width: 40, height: 50, label: "Front" }],
    photoViews: {
      "front": { image: "//conquistadorapparel.com/cdn/shop/t/8/assets/bottle-wrap-original.png", label: "Front", zone: { xPct: 12.9, yPct: 10.6, wPct: 70.7, hPct: 49.9 } },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "tshirt",
    realWidthCm: 51, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "T-Shirt",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTggMyBMNCA2IEwyIDkgTDUgMTEgTDYgOS41IFYyMSBIMTggVjkuNSBMMTkgMTEgTDIyIDkgTDIwIDYgTDE2IDMgQzE2IDQuNyAxNC4yIDYgMTIgNiBDOS44IDYgOCA0LjcgOCAzIFoiLz48L3N2Zz4=",
    category: "tshirt",
    variantLabel: "Homem/Unissexo",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "T-SHIRT",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/1_width_800_height_800_2f479b35-3dcb-4575-9c29-4eb367950bb9.webp?v=1786527187",
        label: "Front",
        zone: { xPct: 0, yPct: 0, wPct: 100, hPct: 100 },
      },
      "back": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/1_width_800_height_800_1_fa92374d-0d31-4275-b1a0-e04ce44a30bf.webp?v=1786527190",
        label: "Back",
        zone: { xPct: 0, yPct: 0, wPct: 100, hPct: 100 },
      },
      "left": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/1_width_800_height_800_3_39e6ffa4-92cf-4270-b618-0c430ca2c56d.webp?v=1786527193",
        label: "Left",
        zone: { xPct: 0, yPct: 0, wPct: 100, hPct: 100 },
      },
      "right": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/1_width_800_height_800_2_3b38ddad-c8ff-44e1-a738-e91dd8d628b5.webp?v=1786527195",
        label: "Right",
        zone: { xPct: 0, yPct: 0, wPct: 100, hPct: 100 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "tshirt-mulher",
    realWidthCm: 45, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "B&C Inspire E150 T-Shirt (Women)",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTggMyBMNCA2IEwyIDkgTDUgMTEgTDYgOS41IFYyMSBIMTggVjkuNSBMMTkgMTEgTDIyIDkgTDIwIDYgTDE2IDMgQzE2IDQuNyAxNC4yIDYgMTIgNiBDOS44IDYgOCA0LjcgOCAzIFoiLz48L3N2Zz4=",
    category: "tshirt",
    variantLabel: "Mulher",
    categoryOrder: 2,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "T-SHIRT-WOMEN",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/bc560333_1d.jpg?v=1786480492",
        label: "Front",
        zone: { xPct: 36.8, yPct: 22, wPct: 26.5, hPct: 33 },
      },
      "back": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-mulher-back-hq2.png?v=1786526824",
        label: "Back",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "right": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-mulher-right-hq2.png?v=1786526830",
        label: "Right",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "left": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-mulher-left-hq2.png?v=1786526836",
        label: "Left",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "tshirt-oversized",
    realWidthCm: 62, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "B&C E220 Oversized T-Shirt (Unisex)",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTggMyBMNCA2IEwyIDkgTDUgMTEgTDYgOS41IFYyMSBIMTggVjkuNSBMMTkgMTEgTDIyIDkgTDIwIDYgTDE2IDMgQzE2IDQuNyAxNC4yIDYgMTIgNiBDOS44IDYgOCA0LjcgOCAzIFoiLz48L3N2Zz4=",
    category: "tshirt",
    variantLabel: "Oversized",
    categoryOrder: 3,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "T-SHIRT-OVERSIZED",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Mens_T-Shirt_Mockup.jpg?v=1786480929",
        label: "Front",
        zone: { xPct: 33.1, yPct: 22.5, wPct: 35.4, hPct: 33 },
      },
      "back": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-oversized-back-hq2.png?v=1786526842",
        label: "Back",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "right": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-oversized-right-hq2.png?v=1786526847",
        label: "Right",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "left": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-oversized-left-hq2.png?v=1786526853",
        label: "Left",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "tshirt-190",
    realWidthCm: 51, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "B&C E190 T-Shirt (Unisex)",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTggMyBMNCA2IEwyIDkgTDUgMTEgTDYgOS41IFYyMSBIMTggVjkuNSBMMTkgMTEgTDIyIDkgTDIwIDYgTDE2IDMgQzE2IDQuNyAxNC4yIDYgMTIgNiBDOS44IDYgOCA0LjcgOCAzIFoiLz48L3N2Zz4=",
    category: "tshirt",
    variantLabel: "Premium",
    categoryOrder: 4,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "T-SHIRT-190",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-190-front-hq2.png?v=1786526859",
        label: "Front",
        zone: { xPct: 35.4, yPct: 22, wPct: 29.1, hPct: 33 },
      },
      "back": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-190-back-hq2.png?v=1786526865",
        label: "Back",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "right": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-190-right-hq2.png?v=1786526871",
        label: "Right",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "left": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/tshirt-190-left-hq2.png?v=1786526877",
        label: "Left",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "hoodie",
    realWidthCm: 58, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Hoodie",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTguMiA1IEw0IDcuNSBMMiAxMC41IEw1IDEyLjMgTDYuMyAxMC43IFYyMSBIMTcuNyBWMTAuNyBMMTkgMTIuMyBMMjIgMTAuNSBMMjAgNy41IEwxNS44IDUiLz48cGF0aCBkPSJNOC4yIDUgQzguMiAyLjUgOS44IDEgMTIgMSBDMTQuMiAxIDE1LjggMi41IDE1LjggNSIvPjxwYXRoIGQ9Ik04LjIgNSBDOSA2LjUgMTAuNCA3IDEyIDcgQzEzLjYgNyAxNSA2LjUgMTUuOCA1Ii8+PHBhdGggZD0iTTEwLjUgNy4zIEwxMC4yIDEwLjUiLz48cGF0aCBkPSJNMTMuNSA3LjMgTDEzLjggMTAuNSIvPjwvc3ZnPg==",
    category: "hoodie",
    variantLabel: "Basic",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "HOODIE",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/hoodie-front-hq2.png?v=1786526883",
        label: "Front",
        zone: { xPct: 30.4, yPct: 22, wPct: 39.1, hPct: 33 },
      },
      "back": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/hoodie-back-hq2.png?v=1786526891",
        label: "Back",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "left": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/hoodie-left-hq2.png?v=1786526897",
        label: "Left",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "right": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/hoodie-right-hq2.png?v=1786526903",
        label: "Right",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "hood-right": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/hoodie-hood-right-hq2.png?v=1786526909",
        label: "Hood right",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
      "hood-left": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/hoodie-hood-left-hq2.png?v=1786526915",
        label: "Hood left",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
    },
  },
  {
    id: "hoodie-inspire",
    realWidthCm: 58, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Hoodie",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTguMiA1IEw0IDcuNSBMMiAxMC41IEw1IDEyLjMgTDYuMyAxMC43IFYyMSBIMTcuNyBWMTAuNyBMMTkgMTIuMyBMMjIgMTAuNSBMMjAgNy41IEwxNS44IDUiLz48cGF0aCBkPSJNOC4yIDUgQzguMiAyLjUgOS44IDEgMTIgMSBDMTQuMiAxIDE1LjggMi41IDE1LjggNSIvPjxwYXRoIGQ9Ik04LjIgNSBDOSA2LjUgMTAuNCA3IDEyIDcgQzEzLjYgNyAxNSA2LjUgMTUuOCA1Ii8+PHBhdGggZD0iTTEwLjUgNy4zIEwxMC4yIDEwLjUiLz48cGF0aCBkPSJNMTMuNSA3LjMgTDEzLjggMTAuNSIvPjwvc3ZnPg==",
    category: "hoodie",
    variantLabel: "Inspire",
    categoryOrder: 2,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "HOODIE-INSPIRE",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "hoodie-inspire-front-v2-hq.png",
        label: "Front",
        zone: { xPct: 34, yPct: 22, wPct: 31.9, hPct: 33 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "hoodie-premium",
    realWidthCm: 58, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Hoodie",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTguMiA1IEw0IDcuNSBMMiAxMC41IEw1IDEyLjMgTDYuMyAxMC43IFYyMSBIMTcuNyBWMTAuNyBMMTkgMTIuMyBMMjIgMTAuNSBMMjAgNy41IEwxNS44IDUiLz48cGF0aCBkPSJNOC4yIDUgQzguMiAyLjUgOS44IDEgMTIgMSBDMTQuMiAxIDE1LjggMi41IDE1LjggNSIvPjxwYXRoIGQ9Ik04LjIgNSBDOSA2LjUgMTAuNCA3IDEyIDcgQzEzLjYgNyAxNSA2LjUgMTUuOCA1Ii8+PHBhdGggZD0iTTEwLjUgNy4zIEwxMC4yIDEwLjUiLz48cGF0aCBkPSJNMTMuNSA3LjMgTDEzLjggMTAuNSIvPjwvc3ZnPg==",
    category: "hoodie",
    variantLabel: "Premium",
    categoryOrder: 3,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "HOODIE-PREMIUM",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/1_width_800_height_800_3259bf3e-52a8-4a15-a145-2308513044b9.webp?v=1786526025",
        label: "Front",
        zone: { xPct: 45, yPct: 45, wPct: 10, hPct: 10 },
      },
    },
  },
  {
    id: "polo",
    realWidthCm: 51, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Polo",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/polo-shirt_63a1a2af-7d26-480b-b8aa-5282a03645d2.png?v=1786456846",
    category: "polo",
    variantLabel: "Unissexo",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "POLO",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "polo-real-front-hq.png",
        label: "Front",
        zone: { xPct: 34.8, yPct: 22, wPct: 30.4, hPct: 33 },
      },
    },
  },
  {
    id: "polo-mulher",
    realWidthCm: 46, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "ID.001 Women Polo (Women)",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/polo-shirt_7a10014f-3719-47f8-acff-da7735771212.png?v=1786456866",
    category: "polo",
    variantLabel: "Mulher",
    categoryOrder: 2,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "POLO-WOMEN",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "polo-mulher-front-hq.png",
        label: "Front",
        zone: { xPct: 36.8, yPct: 22, wPct: 26.3, hPct: 33 },
      },
    },
  },
  {
    id: "polo-lsl",
    realWidthCm: 51, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "My Polo 210 LSL (Men)",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/polo-shirt_927fc73e-8c12-468e-9c4a-a57d8b99eab5.png?v=1786456883",
    category: "polo",
    variantLabel: "Homem (Manga Comprida)",
    categoryOrder: 3,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "POLO-LSL",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "polo-lsl-front-hq.png",
        label: "Front",
        zone: { xPct: 29.3, yPct: 22, wPct: 41.3, hPct: 33 },
      },
    },
  },
  {
    id: "cap",
    realWidthCm: 20, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Caden Cap (Vintage)",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/cap_1.png?v=1786456968",
    category: "cap",
    variantLabel: "Caden",
    categoryOrder: 2,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "CAP",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "cap-real-front-hq.png",
        label: "Front",
        zone: { xPct: 30, yPct: 30, wPct: 30, hPct: 20 },
      },
    },
  },
  {
    id: "cap-trucker",
    realWidthCm: 20, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Rydell Cap (Trucker)",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/cap_5f59aca6-6482-4535-b0a3-17dc6bff36d6.png?v=1786456949",
    category: "cap",
    variantLabel: "Rydell",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "CAP-TRUCKER",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "cap-trucker-front-hq.png",
        label: "Front",
        zone: { xPct: 30, yPct: 30, wPct: 30, hPct: 20 },
      },
    },
  },
  {
    id: "cap-diggs",
    realWidthCm: 20, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "DIGG-S Cap (Vintage)",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/cap_1_14844105-3b7e-47bb-854e-2a50f6b12447.png?v=1786456986",
    category: "cap",
    variantLabel: "DIGG-S",
    categoryOrder: 3,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "CAP-DIGGS",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "cap-diggs-front-hq.png",
        label: "Front",
        zone: { xPct: 30, yPct: 30, wPct: 30, hPct: 20 },
      },
    },
  },
  {
    id: "cap-teon",
    realWidthCm: 20, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Teon Cap (Trucker)",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/cap_4f85ac5c-0a3e-4c69-89ee-d08b9e77b871.png?v=1786457003",
    category: "cap",
    variantLabel: "Teon",
    categoryOrder: 4,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "CAP-TEON",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "cap-teon-front-hq.png",
        label: "Front",
        zone: { xPct: 30, yPct: 30, wPct: 30, hPct: 20 },
      },
    },
  },
  {
    id: "bag",
    realWidthCm: 38, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Tote Bag",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTYgOCBIMTggTDE5IDIxIEg1IFoiLz48cGF0aCBkPSJNOSA4IFY2IEM5IDQgMTAuMyAzIDEyIDMgQzEzLjcgMyAxNSA0IDE1IDYgVjgiLz48L3N2Zz4=",
    category: "bag",
    variantLabel: "Tote Bag",
    categoryOrder: 0,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "BAG",
    showSize: false,
    showColor: false,
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "bag-real-front-hq.png",
        label: "Front",
        zone: { xPct: 25, yPct: 38, wPct: 50, hPct: 42 },
      },
    },
  },
  {
    id: "camisola-mulher",
    realWidthCm: 48, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Camisola",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/shirt-long-sleeve_1_564faf69-5b86-44ff-974c-161b4b80a917.png?v=1786457183",
    category: "camisola",
    variantLabel: "Camisola",
    categoryOrder: 0,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "CREWNECK-WOMEN",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "front": {
        image: "camisola-mulher-front-hq.png",
        label: "Front",
        zone: { xPct: 30.5, yPct: 22, wPct: 38.9, hPct: 33 },
      },
    },
  },
  {
    showColor: true,
    showSize: true,
    id: "patches",
    name: "Patch",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/fabric.png?v=1786537688",
    category: "patches",
    variantLabel: "Patch",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "PATCHES-69687",
    showTechnique: false,
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "unica": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Patches_-_Logo.png?v=1787148119",
        label: "Unica",
        zone: { xPct: 0, yPct: 0, wPct: 100, hPct: 100 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "toalhas",
    realWidthCm: 50, // real-world cm this garment's photo represents (see design-tool.js's Print size pricing)
    name: "Toalha",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Tolhas_59e09d8b-cfb0-43bb-8dcd-da2151fba42f.png?v=1786635839",
    category: "toalhas",
    variantLabel: "Toalha",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "TOALHAS-46967",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "vista-side": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Toalha_-_Branca.png?v=1786712942",
        label: "Vista Side",
        zone: { xPct: 5, yPct: 5, wPct: 90, hPct: 90 },
      },
    },
  },
  {
    id: "mochila-torel-ref-310403",
    name: "Mochila",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Backpack_-_Logo_02b62988-a163-49af-8220-2052a31edbc8.png?v=1786974568",
    category: "mochilas",
    variantLabel: "Mochila",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "MOCHILA-TOREL-REF-310403-43991",
    showSize: false,
    showColor: false,
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Backpak_-_310403_-_no_background.jpg?v=1786974614",
        label: "Frente",
        zone: { xPct: 15.5, yPct: 22.6, wPct: 70, hPct: 70 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "lanyards-planas-ref-140764",
    name: "Lanyards",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/lanyards_-_Logo.png?v=1787147370",
    category: "lanyards",
    variantLabel: "Lanyard",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "LANYARDS-PLANAS-REF-140764-64407",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Lanyards_-_Blank_33ff683a-ef56-45e0-85f5-843676f657ad.png?v=1787147734",
        label: "Frente",
        zone: { xPct: 30, yPct: 25, wPct: 40, hPct: 35 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "patches-2",
    name: "Quadrado",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Patches_-_Logo_63c39a8f-7f12-4353-b5ab-6737926f2c90.png?v=1787148667",
    category: "patches",
    variantLabel: "Quadrado",
    categoryOrder: 2,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "PATCHES-69687",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Patches_-_Logo_f9c9e035-a399-41d5-8532-4c73560c44ca.png?v=1787148428",
        label: "Frente",
        zone: { xPct: 20.9, yPct: 26.1, wPct: 60, hPct: 55 },
      },
    },
  },
  {
    id: "patches-3",
    name: "Emblema",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Patches_-_Emblem.png?v=1787148608",
    category: "patches",
    variantLabel: "Emblema",
    categoryOrder: 3,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "PATCHES-69687",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Patches_-_Emblem_a7906217-9d6b-4e6a-a428-51986e579ccd.png?v=1787148639",
        label: "Frente",
        zone: { xPct: 20, yPct: 15, wPct: 60, hPct: 55 },
      },
    },
  },
  {
    id: "patches-4",
    name: "Redondo",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Patches_-_Round.png?v=1787148987",
    category: "patches",
    variantLabel: "Redondo",
    categoryOrder: 4,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "PATCHES-69687",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Patches_-_Round_5731bdf2-c949-46bb-99da-6b8a1ea1dd82.png?v=1787149019",
        label: "Frente",
        zone: { xPct: 10, yPct: 5, wPct: 80, hPct: 75 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "recynote-a6-ref-ip250572",
    name: "Notes",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/notebook_-_blank.png?v=1788177644",
    category: "note-books",
    variantLabel: "Papelão",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "RECYNOTE-A6-REF-IP250572-71607",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Recynote_-_Blank_2baceb45-40fd-42bb-ae22-95bd185e38ad.png?v=1788177703",
        label: "Frente",
        zone: { xPct: 5, yPct: 0, wPct: 90, hPct: 85 },
      },
    },
  },
  {
    id: "bambook-ref-ip250569",
    name: "Bamboo",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/notebook_-_blank_f82adb98-d74f-41bf-9be3-655230d8e71f.png?v=1788181618",
    category: "note-books",
    variantLabel: "Bamboo",
    categoryOrder: 2,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "BAMBOOK-REF-IP250569-10839",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Bambook_-_Ref._IP250569_-_Blank.png?v=1788181643",
        label: "Frente",
        zone: { xPct: 9.3, yPct: 9.1, wPct: 80, hPct: 75 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "smartphone-charging-board-bacha-ref-ip110581",
    name: "Wooden",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Recharge_-_Logo_b5deeac8-c2cb-4923-947f-eb2f09c71878.png?v=1788183719",
    category: "recharge",
    variantLabel: "Wooden Board",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "SMARTPHONE-CHARGING-BOARD-BACHA-REF-IP11-06295",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frent": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Charging_Board_Bacha_-_IP110581_-_Blank.png?v=1788182677",
        label: "Frent",
        zone: { xPct: 5.9, yPct: 14.5, wPct: 90, hPct: 85 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "phone-stand-celoo",
    name: "Mini Stand",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Recharge_-_Logo_b5deeac8-c2cb-4923-947f-eb2f09c71878.png?v=1788183719",
    category: "recharge",
    variantLabel: "Mini Stand",
    categoryOrder: 2,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "PHONE-STAND-CELOO-34519",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Phone_Stand_Celoo_-_IP110589_-_Blank_Area.png?v=1788183511",
        label: "Frente",
        zone: { xPct: 5, yPct: 5, wPct: 90, hPct: 90 },
      },
    },
  },
  {
    id: "phone-stand-bambase-ref-ip110588",
    name: "Base Stand",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Recharge_-_Logo_b5deeac8-c2cb-4923-947f-eb2f09c71878.png?v=1788183719",
    category: "recharge",
    variantLabel: "Base Stand",
    categoryOrder: 3,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "PHONE-STAND-BAMBASE-REF-IP110588-40695",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Bambase_-_IP110588_-_Blank_Area_c237c4c0-1307-4b27-b004-7ebd566e9171.png?v=1788184444",
        label: "Frente",
        zone: { xPct: 21.4, yPct: 26.5, wPct: 60, hPct: 55 },
      },
    },
  },
  {
    id: "phone-stand-bambell-ref-ip110587",
    name: "Bamboo Stand",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Recharge_-_Logo_b5deeac8-c2cb-4923-947f-eb2f09c71878.png?v=1788183719",
    category: "recharge",
    variantLabel: "Bamboo Stand",
    categoryOrder: 4,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "PHONE-STAND-BAMBELL-REF-IP110587-68919",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Phone_Stand_Bambell_-_IP110587_-_Blank_Area.png?v=1788184952",
        label: "Frente",
        zone: { xPct: 5, yPct: 5, wPct: 90, hPct: 90 },
      },
    },
  },
  {
    id: "bambootune-stand-ref-ip110596",
    name: "Canetas Som",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Recharge_-_Logo_b5deeac8-c2cb-4923-947f-eb2f09c71878.png?v=1788183719",
    category: "recharge",
    variantLabel: "Canetas Som",
    categoryOrder: 5,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "BAMBOOTUNE-STAND-REF-IP110596-55895",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/BambooTune_-_IP110596_-_Blank_Area.png?v=1788185728",
        label: "Frente",
        zone: { xPct: 32.9, yPct: 32.6, wPct: 40, hPct: 35 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "cutting-board-bamboard-ref-ip260289",
    name: "Bamboo",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Cutting_Board_-_Logo_0db6d46e-fa8c-45e7-8117-9abfca2ddb2e.png?v=1788186765",
    category: "cutting",
    variantLabel: "Bamboo",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "CUTTING-BOARD-BAMBOARD-REF-IP260289-68727",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Cutting_Board_-_IP260289_-_Blank.png?v=1788186587",
        label: "Frente",
        zone: { xPct: 15, yPct: 32.3, wPct: 70, hPct: 65 },
      },
    },
  },
  {
    id: "cup-bases-bamcott-ref-ip260291",
    name: "Bases",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTQgNCBIMTUgVjE3IEMxNSAxOSAxMy41IDIwIDEyIDIwIEg3IEM1LjUgMjAgNCAxOSA0IDE3IFoiLz48cGF0aCBkPSJNMTUgNi41IEgxOCBDMTkuNSA2LjUgMjAuNSA3LjcgMjAuNSA5LjUgQzIwLjUgMTEuMyAxOS41IDEyLjUgMTggMTIuNSBIMTUiLz48L3N2Zz4=",
    category: "mug",
    variantLabel: "Bases",
    categoryOrder: 3,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "CUP-BASES-BAMCOTT-REF-IP260291-28023",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Base_BamCott_-_IP260291_-_Blank.png?v=1788187197",
        label: "Frente",
        zone: { xPct: 2.6, yPct: 24.1, wPct: 70, hPct: 65 },
      },
    },
  },
  {
    id: "icebott-ref-ip260267",
    name: "Manga Frapê",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTEwIDIgSDE0IFY1LjUgTDE1LjUgNy41IFYyMSBDMTUuNSAyMiAxNC43IDIyLjUgMTMuOCAyMi41IEgxMC4yIEM5LjMgMjIuNSA4LjUgMjIgOC41IDIxIFY3LjUgTDEwIDUuNSBaIi8+PHBhdGggZD0iTTkgMTIgSDE1Ii8+PC9zdmc+",
    category: "bottle",
    variantLabel: "Manga Frapê",
    categoryOrder: 2,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "ICEBOTT-REF-IP260267-61015",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Icebott_-_IP260267_-_Blank.png?v=1788188528",
        label: "Frente",
        zone: { xPct: 21.6, yPct: 41.3, wPct: 60, hPct: 55 },
      },
    },
  },
  {
    showTechnique: true,
    showColor: true,
    showSize: true,
    id: "umbrella-stoprai-ref-ip350377",
    name: "Guarda Chuva EVA",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Umbrella_-_Logo_6f9c79ed-abb2-4248-a9ef-cab1720d8400.png?v=1788189366",
    category: "guarda-chuva",
    variantLabel: "Umbrella EVA",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "UMBRELLA-STOPRAI-REF-IP350377-42295",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Umbrella_Stoprai_-_IP3503877_-_Blank.png?v=1788189295",
        label: "Frente",
        zone: { xPct: 35.7, yPct: 20.9, wPct: 40, hPct: 35 },
      },
    },
  },
  {
    id: "strawhat-ref-380410-satin-strap-ref-mv700119",
    name: "Strawhat",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Strawhat_-_Logo.png?v=1788273087",
    category: "cap",
    variantLabel: "Strawhat",
    categoryOrder: 5,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "STRAWHAT-REF-380410-SATIN-STRAP-REF-MV70-52567",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/380410_00_586083e8-0167-427f-83a8-d59b54799275.jpg?v=1788273159",
        label: "Frente",
        zone: { xPct: 24.9, yPct: 32.1, wPct: 50, hPct: 45 },
      },
    },
  },
  {
    id: "avental-adjust-ref-ip260294",
    name: "Adjust",
    icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Aprom_-_Logo.png?v=1788276991",
    category: "avental",
    variantLabel: "Adjust",
    categoryOrder: 1,
    // Added via the Chrome extension "Painel do Editor" — the owner's own
    // product photo(s), used as-is (see photoViews below), not vetorized.
    productType: "AVENTAL-ADJUST-REF-IP260294-79863",
    viewBox: "0 0 200 240",
    svgPaths: {
      body: "M60,40 L140,40 L140,190 L60,190 Z",
    },
    safeZones: [{ x: 30, y: 25, width: 40, height: 55, label: "Front" }],
    photoViews: {
      "frente": {
        image: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/260294_80_01_2471a1f6-abbb-45e0-8515-197b08cdec1e.jpg?v=1788277079",
        label: "Frente",
        zone: { xPct: 20, yPct: 27.8, wPct: 60, hPct: 60 },
      },
    },
  },
];

// Display info for the "Choose Garment" category tile, needed only for
// categories that group more than one garment (currently just "cap": Trucker
// + Vintage). Single-garment categories don't need an entry here — the
// picker just falls back to that garment's own name/icon (see
// GARMENT_CATEGORIES in design-tool.js).
window.GARMENT_CATEGORY_META = {
  "avental": { name: "Avental", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Aprom_-_Logo.png?v=1788276991" },
  "guarda-chuva": { name: "Guarda Chuva", icon: "⭐" },
  "cutting": { name: "Cutting", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Cutting_Board_-_Logo.png?v=1788186544" },
  "recharge": { name: "Recharge", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Recharge_-_Logo_b5deeac8-c2cb-4923-947f-eb2f09c71878.png?v=1788183719" },
  "note-books": { name: "Note Books", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/notebook_-_blank.png?v=1788177644" },
  "lanyards": { name: "Lanyards", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/lanyards_-_Logo.png?v=1787147370" },
  "mochilas": { name: "Mochilas", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/Backpack_-_Logo_02b62988-a163-49af-8220-2052a31edbc8.png?v=1786974568" },
  "toalhas": { name: "Toalhas", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/toalha-de-banho_e51679c6-cc98-43f6-bd78-10cb2f7e2a0f.png?v=1786637193" },
  "patches": { name: "Patches", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/fabric.png?v=1786537688" },
  "polo": { name: "Polo", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/polo-shirt_562b58c1-efd7-4d0d-a175-65deb0c02b84.png?v=1786456708" },
  "tshirt": { name: "T-Shirt", icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTggMyBMNCA2IEwyIDkgTDUgMTEgTDYgOS41IFYyMSBIMTggVjkuNSBMMTkgMTEgTDIyIDkgTDIwIDYgTDE2IDMgQzE2IDQuNyAxNC4yIDYgMTIgNiBDOS44IDYgOCA0LjcgOCAzIFoiLz48L3N2Zz4=" },
  "cap": { name: "Cap", icon: "https://cdn.shopify.com/s/files/1/0957/8364/9655/files/cap.png?v=1786456932" },
};

window.GARMENT_COLORS = [
  { hex: "#FFFFFF", name: "White" },
  { hex: "#000000", name: "Black" },
  { hex: "#1E3A8A", name: "Navy" },
  { hex: "#DC2626", name: "Red" },
  { hex: "#059669", name: "Green" },
  { hex: "#F59E0B", name: "Yellow" },
];

// Real Shopify products in the store (conquistadorapparel.com), mapped to
// each garment above. Each garment is added to the cart as its real
// product/variant (a plain blank), and the customer's chosen colour + logo
// placement are attached as line item properties for the shop to fulfil
// manually — this is a made-to-order shop, so the cart line is a
// placeholder SKU, not a promise of exact off-the-shelf colour matching.
//
// polo / cap-trucker / mug / bottle: NOT yet linked to a real Shopify
// product (variantId/sizes left null) — the design/preview experience works
// fully, but Add to Cart will show a friendly "not available yet" message
// until real product+variant IDs are filled in below.
window.GARMENT_PRODUCTS = {
  tshirt: {
    title: "Unisex Classic Tee (White)",
    hasSizes: true,
    sizes: {
      S: 57008840049015,
      M: 57008840081783,
      L: 57008840114551,
      XL: 57008840147319,
      "2XL": 57008840180087,
      "3XL": 57008840212855,
      "4XL": 57008840245623,
      "5XL": 57008840278391,
    },
  },
  hoodie: {
    title: "Unisex Hoodie",
    hasSizes: true,
    sizes: {
      S: 56086607102327,
      M: 56086607135095,
      L: 56086607167863,
      XL: 56086607200631,
      "2XL": 56086607233399,
      "3XL": 56086607266167,
    },
  },
  polo: {
    title: "Polo",
    hasSizes: true,
    sizes: { S: null, M: null, L: null, XL: null, "2XL": null },
  },
  cap: {
    title: "Foam Trucker Hat",
    hasSizes: false,
    variantId: 56102849970551,
  },
  "cap-trucker": {
    title: "Trucker Cap",
    hasSizes: false,
    variantId: null,
  },
  "mug": { name: "Mugs", icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTQgNCBIMTUgVjE3IEMxNSAxOSAxMy41IDIwIDEyIDIwIEg3IEM1LjUgMjAgNCAxOSA0IDE3IFoiLz48cGF0aCBkPSJNMTUgNi41IEgxOCBDMTkuNSA2LjUgMjAuNSA3LjcgMjAuNSA5LjUgQzIwLjUgMTEuMyAxOS41IDEyLjUgMTggMTIuNSBIMTUiLz48L3N2Zz4=" },
  bottle: {
    title: "Stainless Bottle",
    hasSizes: false,
    variantId: null,
  },
  bag: {
    title: "Tote Bag",
    hasSizes: false,
    variantId: null,
  },
};
